import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  portalConfigurations: [],
  activePortalConfiguration: null,
};

const portalSlice = createSlice({
  name: "portal",
  initialState,
  reducers: {
    setPortalConfigurations: (state, action) => {
      state.portalConfigurations = action.payload;
    },
    setActivePortalConfiguration: (state, action) => {
      state.activePortalConfiguration = action.payload;
    },
    updatePortalStatusInList: (state, action) => {
      const { id, is_active } = action.payload;
      const portal = state.portalConfigurations.find(p => p.id === id);
      if (portal) {
        portal.is_active = is_active;
      }
    },
  },
});

export const {
  setPortalConfigurations,
  setActivePortalConfiguration,
  updatePortalStatusInList,
} = portalSlice.actions;

export const selectPortalConfigurations = state => state.portal.portalConfigurations;
export const selectActivePortalConfiguration = state => state.portal.activePortalConfiguration;

export default portalSlice.reducer;
